<template>
    <div v-if="elementShown" class="container position-relative cinema-cards">
        <div v-if="showSpinner" class="absolute-fill z-index-2 text-center cards-spinner">
            <i class="far fa-spinner-third fa-spin cards-spinner-icon"></i>
        </div>

        <div v-if="noResults" class="mt-5 text-center">
            Geen bioscopen gevonden op basis van je zoekcriteria
        </div>

        <div class="row">
            <div v-for="(cinema, index) in cinemas" :class="columnClasses">
                <cinema-card :poster="cinema.poster || defaultPoster"
                             :name="cinema.name"
                             :slug="cinema.slug"
                             :single-url="cinema.singleUrl"
                             :website="cinema.website"
                             :phone="cinema.phone"
                             :full-address="cinema.fullAddress">
                </cinema-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            columnClasses: {
                type: String,
                default: 'col-md-6 col-lg-4 col-xl-3',
            },
            showElement: {
                type: Boolean,
                default: true,
            },
            citySlug: {
                type: String,
            },
            items: {
                type: Array,
                defaukt: []
            },
            showSpinnerInitially: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                elementShown: this.showElement,
                showSpinner: this.showSpinnerInitially,
                noResults: false,
                cinemas: [],
                defaultPoster: MrMovie.defaults.imagePaths.cinemaSmall,
                searchByFilters: null
            };
        },
        mounted() {

            if(this.citySlug) {
                MrMovie.pageFilter.addFilters('city', [this.citySlug]);
            }

            VueEvents.$on('loaded_cinemas', (cinema) => {
                if(typeof cinema.items !== 'undefined') {
                    this.noResults = false;
                    this.showSpinner = false;
                    this.cinemas = cinema.items
                } else {
                    this.noResults = true;
                }
            });

            // Listen for events to show/hide the cards
            VueEvents.$on('show_cinema_cards', show => {
                this.elementShown = show;
            });
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/cinemas/CinemaCards.vue